<template>
  <Form>
    <div class="registerbox">
      <div class="register">
        <div class="register-l">
          <div class="register-bg"></div>
        </div>
        <div class="register-r">
          <h3 class="title">{{title}}</h3>
          <router-view/>
        </div>
      </div>
    </div>
  </Form>
</template>

<script>
export default {
  computed:{
    title(){
      switch(this.$route.name){
        case 'register':
        return this.$t('title.w1')
        case 'login':
        return this.$t('title.w2')
        case 'forgetpwd':
        return this.$t('title.w3')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.registerbox {
  background: #f1f2f5;
  width: 100%;
  height: 742px;
  padding-top: 65px;
  .register {
    width: 1000px;
    height: 600px;
    border-radius: 8px;
    background: #fff;
    margin: 0 auto;
    display: flex;
    .register-l {
      width: 580px;
      height: 100%;
      padding-top: 102px;
      padding-left: 60px;
      position: relative;
      .register-bg {
        width: 494px;
        height: 397px;
        background: url("../../assets/login_bg.png") no-repeat;
        background-size: cover;
      }
    }
    .register-r {
      width: 420px;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .title {
        height: 33px;
        font-size: 24px;
        font-weight: bold;
        color: rgba(35, 35, 37, 1);
        line-height: 33px;
        margin-bottom: 35px;
      }
    }
  }
}
</style>


